const weekdayShortNamesPtBr = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

export const monthShortNamesPtBr = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

export const monthLongNamesPtBr = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
];

export function getMinDate(autorizacoes) {
    const today = new Date();

    let minDate;

    if (autorizacoes.includes('Adm') || autorizacoes.includes('Fechamento')) {
        minDate = new Date('2025-01-01');
    } else {
        minDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    }

    return minDate;
}

export function formatDate(value) {
    return new Date(value).toLocaleString('pt-BR');
}

const parseDateOrThrow = (value) => {
    if (value === null || value === undefined || value === '') return '';

    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
        throw new Error(`Data inválida recebida: ${value}`);
    }

    return date;
};

export function formatDatePtBr(value) {
    const date = parseDateOrThrow(value);
    if (date === '') return '';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}

export function formatDateTimePtBr(value) {
    const date = parseDateOrThrow(value);
    if (date === '') return '';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year}, ${hours}:${minutes}`;
}

// Datas em AAAA-MM-DD: payload do backend e chave de dia em gráficos/arquivos.
export const formatIsoDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

const backendMonthNameToIndex = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11
};

export const parseBackendDate = (value) => {
    if (!value) return null;
    if (value instanceof Date) return value;

    const dateText = String(value);
    const isoMatch = dateText.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?)?/);

    if (isoMatch) {
        const [, year, month, day, hour = '0', minute = '0', second = '0'] = isoMatch;
        return new Date(
            Number(year),
            Number(month) - 1,
            Number(day),
            Number(hour),
            Number(minute),
            Number(second)
        );
    }

    const rfcGmtMatch = dateText.match(/^(?:[A-Za-z]{3},\s*)?(\d{1,2})\s([A-Za-z]{3})\s(\d{4})\s(\d{2}):(\d{2})(?::(\d{2}))?\sGMT$/);

    if (rfcGmtMatch) {
        const [, day, monthName, year, hour, minute, second = '0'] = rfcGmtMatch;
        return new Date(
            Number(year),
            backendMonthNameToIndex[monthName],
            Number(day),
            Number(hour),
            Number(minute),
            Number(second)
        );
    }

    return new Date(value);
};

export const formatBackendDatePtBr = (value, fallback = '') => {
    const date = parseBackendDate(value);

    return date ? formatDatePtBr(date) : fallback;
};

export const formatBackendDateTimePtBr = (value, fallback = '') => {
    const date = parseBackendDate(value);

    return date ? formatDateTimePtBr(date) : fallback;
};

export function formatDateTimeTextPtBr(value) {
    const date = parseDateOrThrow(value);
    if (date === '') return '';

    const weekday = weekdayShortNamesPtBr[date.getDay()];
    const day = String(date.getDate()).padStart(2, '0');
    const month = monthShortNamesPtBr[date.getMonth()];
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${weekday}, ${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
}

export const getCurrentMonthStart = () => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), 1);
};

export const getMonthsAgoStart = (months) => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth() - months, 1);
};

export const getCurrentYearStart = () => {
    const today = new Date();
    return new Date(today.getFullYear(), 0, 1);
};

export const formatMonthParam = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
};

// Endpoints antigos esperam o mês sem zero à esquerda (AAAA-M).
export const formatShortMonthParam = (date) => `${date.getFullYear()}-${date.getMonth() + 1}`;

export const parseMonthParam = (value) => {
    const [year, month] = value.split('-').map(Number);
    return new Date(year, month - 1, 1);
};

export const parseMonthParamOrCurrent = (value) => (value ? parseMonthParam(value) : getCurrentMonthStart());

export const normalizeMonthStart = (date) => new Date(date.getFullYear(), date.getMonth(), 1);

export const normalizeDayStart = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const getDayCountInRange = (startDate, endDate) => Math.round(
    (normalizeDayStart(endDate) - normalizeDayStart(startDate)) / 86400000
) + 1;

export const isBeforeToday = (date) => normalizeDayStart(date) < normalizeDayStart(new Date());

export const getPreviousDay = () => {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    return date;
};

export const getPreviousDayMonthStart = () => normalizeMonthStart(getPreviousDay());

export const getDaysUntilDate = (value) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const targetDate = new Date(value);
    targetDate.setHours(0, 0, 0, 0);

    return Math.ceil((targetDate - today) / 86400000);
};

export const isValidDate = (value) => value instanceof Date && !Number.isNaN(value.getTime());

export const isValidPickerValue = (value, context) => (
    value === null || (isValidDate(value) && context.validationError === null)
);

export function getMonthYearDatePickerProps(setValue) {
    return {
        views: ['month', 'year'],
        openTo: 'month',
        format: 'M/yyyy',
        shouldRespectLeadingZeros: true,
        onChange: (value, context) => {
            if (isValidPickerValue(value, context)) {
                setValue(value);
            }
        }
    };
}

export const getDaysInMonth = (dateTime) => new Date(
    dateTime.getFullYear(),
    dateTime.getMonth() + 1,
    0
).getDate();

export const formatMonthShortPtBr = (value) => {
    const date = parseBackendDate(value);
    if (!date) return '';

    return `${monthShortNamesPtBr[date.getMonth()]}/${String(date.getFullYear()).slice(-2)}`;
};

export const formatMonthYearPtBr = (value) => {
    const date = parseBackendDate(value);
    if (!date) return '';

    return `${monthLongNamesPtBr[date.getMonth()]} de ${date.getFullYear()}`;
};

export const formatDateLabelPtBr = (value, fallback = 'Pendente') => (
    value ? formatDatePtBr(value) : fallback
);

export const formatMonthYearLabelPtBr = (value, fallback = 'Não selecionado') => (
    value ? formatMonthYearPtBr(value) : fallback
);

export const getMonthKey = (value) => {
    const date = parseBackendDate(value);
    if (!date) return '';

    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
};
